import moment from 'moment';
import { toast } from 'react-toastify';

import { User, Event } from '../types';

import { isEmpty } from '.';

export const canEditEvent = (event: Event | null) => {
  let now = moment().utc();

  if (!event || isEmpty(event)) return false;

  return !event.startDate || moment(event.startDate).isSameOrAfter(now, 'day');
};

export const getSampleSelected = (array: any[], isUnselected?: boolean) => {
  if (!array) return [];
  if (isUnselected) return array.filter((el) => !el.isSelected);
  return array.filter((el) => el.isSelected);
};

export const getSampleSuffix = (isSample: boolean) => {
  if (isSample) return '-[Sample]';
  else return '';
};

export const getNameForTracking = (user: User) => {
  return user.firstName || user.lastName
    ? `${user.firstName ?? ''} ${user.lastName ?? ''}`
    : '';
};

export const isGodUser = (user: User) => {
  return user.session.roles.some((role: any) => role.type === 'god');
};

export const toggleAdminMode = (
  user: User,
  adminMode: boolean,
  setAdminMode: (adminMode: boolean) => void,
) => {
  if (!isGodUser(user)) return;

  setAdminMode(!adminMode);
  toast(`🕹️ Admin mode turned ${adminMode ? 'OFF' : 'ON'}!`);
};
